<template>
  <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
    <van-search
      v-model="keyword"
      show-action
      shape="round"
      placeholder="搜索关键字"
      @search="onSearch"
    >
      <template #action>
        <div @click="onClickButton" class="search_btn">搜索</div>
      </template>
    </van-search>
    <van-list
      v-model:loading="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
      :sticky="true"
    >
      <Slide :dataModal="dataModal" />
      <div class="summary" v-if="dataModal.summary">
        <div class="summary_text">{{ dataModal.summary }}</div>
      </div>
      <div style="margin: 0 20px">
        <van-swipe
          class="my-swipe"
          :autoplay="3000"
          indicator-color="white"
          lazy-render
        >
          <van-swipe-item
            v-for="item in dataModal.advertList"
            :key="item.id"
            v-on:click="onClick(item)"
          >
            <img class="img" :src="item.img" alt=""
          /></van-swipe-item>
        </van-swipe>
      </div>

      <div v-for="item in dataModal.list" :key="item.id">
        <!-- 左文右图 -->
        <NewsCell v-if="item.listType == 0" :item="item" />
        <!-- 大图 -->
        <TopicCell v-if="item.listType == 1" :item="item" />
        <!-- 三图模式 -->
        <PicturesCell v-if="item.listType == 2" :item="item" />
        <!-- 纯标题 -->
        <TextCell v-if="item.listType == 8" :item="item" />
      </div>
    </van-list>
  </van-pull-refresh>
</template>

<script>
import {
  Swipe,
  SwipeItem,
  List,
  PullRefresh,
  Image as VanImage,
  Search,
} from "vant";
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import NewsCell from "../components/NewsCell.vue";
import TopicCell from "../components/TopicCell.vue";
import TextCell from "../components/TextCell.vue";

import Slide from "../components/Slide.vue";
import PicturesCell from "../components/PicturesCell.vue";
import { useRouter } from "vue-router";
import "../plugins/bridge.js";
export default {
  name: "NewsList",
  props: {
    category: Object,
  },
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [VanImage.name]: VanImage,
    [Search.name]: Search,
    NewsCell,
    TopicCell,
    TextCell,
    Slide,
    PicturesCell,
  },
  setup() {
    const loading = ref(false);
    const finished = ref(false);
    const refreshing = ref(false);
    const page = ref(1);
    const pageSize = ref(20);
    const $router = useRouter();
    const store = useStore();

    const keyword = ref("");
    const onSearch = (val) => {
      keyword.value = val;
      onRefresh();
    };
    const onClickButton = () => {
      onRefresh();
    };
    const onClick = (item) => {
      console.log(item);
      const userAgentString = navigator.userAgent.toLocaleLowerCase();
      console.log(userAgentString);
      if (item.url) {
        if (userAgentString.indexOf("zsrbapp") < 0) {
          window.open(item.url, "_blank");
        } else {
          store
            .dispatch("getViewInfoBridging", {
              id: item.id,
            })
            .then((res) => {
              window.ZsrbApp.call("viewInfo", res);
            });
        }
      }
    };
    const onLoad = () => {
      const params = {
        id: $router.currentRoute.value.query.id,
        page: page.value,
        pageSize: pageSize.value,
        keyword: keyword.value,
      };
      store.dispatch("getDataModal", {
        params,
        loading,
        finished,
        refreshing,
      });
      page.value++;
    };

    const onRefresh = () => {
      // 清空列表数据
      finished.value = false;
      loading.value = true;
      page.value = 1;
      onLoad();
    };

    const onManRefresh = () => {
      refreshing.value = true;
      finished.value = false;
      loading.value = true;
      page.value = 1;
      onLoad();
    };

    onMounted(() => {
      onRefresh();
    });

    return {
      dataModal: computed(() => store.state.dataModal),
      onLoad,
      onRefresh,
      onManRefresh,
      onClick,
      loading,
      finished,
      refreshing,
      keyword,
      onSearch,
      onClickButton,
    };
  },
};
</script>

<style lang="scss" scoped>
.slide {
  width: 100vw;
  height: 56vw;
  .slide-item {
    width: 100vw;
    height: 100%;
  }
}
:deep(.van-swipe__indicators) {
  display: none;
}
.advert {
  width: 100vw;
}
.summary {
  padding: 0 20px;
  margin: 10px 0;
  .summary_text {
    padding: 10px;
    color: rgba(16, 16, 16, 1);
    background-color: rgba(248, 248, 248, 1);
    font-size: 14px;
    text-align: left;
  }
}

.my-swipe {
  margin-bottom: 10px;
  .img {
    width: 100%;
    height: auto;
  }
}

.slide-bottom-container {
  background-color: rgba($color: #000000, $alpha: 0.6);
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: absolute;
  right: 0px;
  bottom: 0px;
  width: 100%;
  height: 8vw;
}
.title {
  font-size: 4.53vw;
  color: white;
  margin-left: 10px;
}
.custom-indicator {
  font-size: 12px;
  display: flex;
  align-items: center;
  height: 100%;
  margin: 0 10px;
  .bot {
    width: 4px;
    height: 4px;
    background-color: white;
    border-radius: 2px;
    margin-right: 10px;
  }
  .bot-active {
    width: 4px;
    height: 4px;
    background-color: red;
    border-radius: 2px;
    margin-right: 10px;
  }
}
.search_btn {
  font-size: 16px;
  color: #565555;
}
</style>
